import { makeStyles, Theme } from '@material-ui/core/styles';

import { colors } from 'theme/colors';

export const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    flexDirection: 'column',
  },
  companyInfo: {
    marginTop: 24,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: theme.spacing(2),
  },
  companyInfoFormAndNav: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    flex: 1,
    height: '100%',
    marginLeft: 24,
    '@media (max-width: 768px)': {
      marginLeft: 0,
    },
  },
  companyInfoForm: {
    padding: 30,
    paddingBottom: 44,
    minHeight: 275,
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
  },

  input: {
    marginBottom: 28,
    maxWidth: 500,
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      maxWidth: '100%',
    },
  },
  errorText: {
    color: colors.ERROR,
  },
  avatarEditable: {
    width: '50%',
  },
  paymentInfoBlock: {
    marginTop: theme.spacing(2),
    marginBottom: 'auto',

    [theme.breakpoints.down('xs')]: {
      marginBottom: 0,
    },
  },
  infoBlockHeader: {
    fontWeight: 600,
    marginBottom: theme.spacing(3),
    textTransform: 'uppercase',
  },
  saveBar: {
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 24px)',
      alignSelf: 'flex-end',
    },
    [theme.breakpoints.only('sm')]: {
      width: '100%',
      alignSelf: 'flex-end',
    },
  },
}));
